import React, { Suspense } from 'react';
import { useLocation } from 'react-router-dom';

import LoadingScreen from '../../../components/LoadingScreen';

const CategoryComponent = React.lazy(() => import('./components/CategoryList'));

const CategoryList = () => {
  const { pathname } = useLocation();
  return (
    <div>
      <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')} />}>
        <CategoryComponent />
      </Suspense>
    </div>
  );
}

export default CategoryList;